import EmailSentSuccess from "./EmailSentSuccess";
export default EmailSentSuccess;
